// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Oe5C","footer":"styles_footer__WjFTD","passCodeTooltip":"styles_passCodeTooltip__WPcMB"};